export default __webpack_public_path__ + "static/media/keypress.700ed2f1.mp3";